export function isInfoNeeded(label: { name: string }): boolean {
  return label.name === 'info needed';
}

export function isResolution(label: { group: string | null }): boolean {
  return label.group === '60. resolution';
}

export function isFullyResolved(label: { name: string }): boolean {
  return label.name === 'resolved';
}
